<template>
    <form>
        <div class="edit-control">
            <h4 class="card-title">{{ $t('medium_grant.logical__1_subtitle') }}</h4>
            <div class="row">
                <div class="col-lg-4">
                    <h3>{{ $t('monitoring.field_download_logframe_table') }}</h3>
                    <p>{{ $t('monitoring.field_subtitle_download_logframe_table') }}</p>
                </div>
                <div class="col-lg-2">
                    <a href="/files/en/RRG/RRG_Logframe_blank_template_Sept-2020.xlsx"
                        target="_blank"
                       class="ml-2 btn btn-simple btn-primary">{{ $t('monitoring.button__download_logframe_template') }} <i
                        class="tim-icons icon-cloud-download-93 ml-2"></i></a>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group file-group">
                        <p v-if="!MonitoringForm.files.revised_logframe.logframe">{{ $t('monitoring.title_upload_logframe') }}</p>
                        <upload-file
                            v-if="MonitoringForm.initialized"
                            v-model="MonitoringForm.files.revised_logframe.logframe"
                            class="upload-file"
                            section="revised_logframe.logframe"
                            :select-text="$t('monitoring.button__upload_logframe')"
                            :file-data="MonitoringForm.files.revised_logframe.logframe"
                            :is-editable="isUploadEditable"
                            :model-name="'Monitoring'"
                            :size-limit="MonitoringForm.fileSizeLimit"
                        >
                        </upload-file>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <h3>{{ $t('monitoring.field_download_logframe_indicators') }}</h3>
                </div>
                <div class="col-lg-2">
                    <a href="/files/en/BIOPAMA_AC_Indicators_Portal_EN_FR-2020.pdf"
                        target="_blank"
                       class="ml-2 btn btn-simple btn-primary">{{ $t('monitoring.button__download_indicators_template') }} <i
                        class="tim-icons icon-cloud-download-93 ml-2"></i></a>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <!-- Title of the project -->
                    <div class="form-group">
                    <textarea
                        class="form-control"
                        name="logical.projectTitle"
                        disabled
                        v-model="MonitoringForm.title"
                        :error="getError('logical.projectTitle')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.logical__1_project_title')"
                        :label="$t('medium_grant.logical__1_project_title')"
                        :placeholder="$t('medium_grant.logical__1_project_title')"
                    >
                    </textarea>
                    </div>

                    <!-- Organisation -->
                    <div class="form-group">
                    <textarea
                        class="form-control"
                        name="revised_logframe.organisation"
                        v-model="MonitoringForm.model.revised_logframe.organisation"
                        :error="getError('revised_logframe.organisation')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.logical__1_organisation')"
                        :label="$t('medium_grant.logical__1_organisation')"
                        :placeholder="$t('medium_grant.logical__1_organisation')"
                    >
                    </textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div>
                        <h4 class="card-title pb-0 mb-0 mt-4"><strong>{{ $t('medium_grant.logical__1_priority_action')
                            }}</strong></h4>
                        <p class="mt-2" v-if="MonitoringForm.model.revised_logframe.enhace_management">
                            {{$t('medium_grant.technical__1_enhace_management')}}
                        </p>
                        <p class="mt-2" v-if="MonitoringForm.model.revised_logframe.enforce_legal">
                            {{$t('medium_grant.technical__1_enforce_legal')}}
                        </p>
                        <p class="mt-2" v-if="MonitoringForm.model.revised_logframe.support_local">
                            {{$t('medium_grant.technical__1_support_local')}}
                        </p>
                    </div>

                    <table class="mt-5 table-bordered" style="table-layout: fixed" width="100%">
                        <thead class="text-center">
                        <th class="align-baseline" width="16%">
                            {{$t('medium_grant.logical__1_results')}} <br/>
                            {{$t('medium_grant.logical__1_results_direct_tangible')}}
                            <br/> <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_ecpcm_guidelines')}}</span>
                            <br/> <a class="text-body"
                                     href="https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf"
                                     target="_blank">https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_indicator')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_indicator_evidence')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_baseline')}} <br/>
                            <span class="font-weight-normal">{{$t('medium_grant.logical__1_reference_year')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_target')}} <br/>
                            <span class="font-weight-normal">{{$t('medium_grant.logical__1_reference_year')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_source_verification')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_source_verification_ecpcm')}}</span>
                        </th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in MonitoringForm.model.revised_logframe.timeline_results"
                            :key="'result_'+index">
                            <td>
                                <h4><strong>{{$t('medium_grant.technical__8_timeline_result') + ' ' + (index +
                                    1)}}.</strong></h4>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.indicator"
                                >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.baseline"
                                >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.target"
                                >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.source"
                                >
                                </textarea>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="mt-5 table-bordered" width="100%">
                        <thead class="text-center">
                        <th class="align-baseline" width="25%">
                            {{$t('medium_grant.logical__1_activities')}} <br/>
                            {{$t('medium_grant.logical__1_activities_actions')}}
                            <br/> <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_ecpcm_guidelines')}}</span>
                            <br/>
                            <a class="text-body"
                               href="https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf"
                               target="_blank">https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                        </th>
                        <th class="align-middle" width="50%">
                            {{$t('medium_grant.logical__1_activities_deliverable')}} <br/>
                        </th>
                        <th class="align-baseline" width="25%">
                            {{$t('medium_grant.logical__1_source_verification')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_source_verification_ecpcm')}}</span>
                        </th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in MonitoringForm.model.revised_logframe.timeline_results"
                            :key="'result2_'+index">
                            <td>
                                <h4><strong>{{$t('medium_grant.technical__8_timeline_result') + ' ' + (index
                                    +1)}}</strong></h4>
                                <div v-for="(activity, activityIndex) in item.activities"
                                     :key="'activity_'+activityIndex">
                                    <h5>
                                        <strong>{{$t('medium_grant.technical__8_timeline_activity') + ' ' + (index
                                            +1)}}.{{activityIndex+1}}:</strong>
                                        <span class="ml-3">{{activity.name}}</span>
                                    </h5>
                                </div>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.deliverable"
                                >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.source2"
                                >
                                </textarea>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <p class="mt-5">
                        {{$t('medium_grant.logical__1_info_simplified')}}
                        <a class="text-body" target="_blank"
                           href="http://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf">http://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                    </p>
                </div>
            </div>
        </div>

        <div v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN)" class="clearance-box mt-5">
            <div class="col-12 pl-0 pr-0" style="overflow: hidden">
                <div class="clearance-bar">
                    <label>{{ $t('monitoring.title_clearance_box') }}</label>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="cleared-with-condition"
                           v-model="MonitoringForm.model.revised_logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_cleared_under_conditions') }}</label>
                    </radio>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="cleared"
                           v-model="MonitoringForm.model.revised_logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_cleared') }}</label>
                    </radio>
                    <radio name="report.clearance"
                           class="form-check-inline"
                           value="not-cleared"
                           v-model="MonitoringForm.model.revised_logframe.clearance"
                           :disabled="!isClearanceEditable"
                    >
                        <label>{{ $t('monitoring.field_title_not_cleared') }}</label>
                    </radio>
                </div>
                <comment-box
                    class="form-group"
                    v-model="MonitoringForm.model.revised_logframe.clearance_comments"
                    :is-editable="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && MonitoringForm.isEditable"
                    :comments="MonitoringForm.model.revised_logframe.clearance_comments"
                    :pull-right="false">
                </comment-box>
                <base-button
                    v-if="this.isClearanceEditable"
                    type="primary"
                    class="validate-report pull-right mb-3 mr-3"
                    @click="validateLogframe"
                    >
                    {{ $t('monitoring.button_title_validate_logframe') }}
                </base-button>
            </div>
        </div>
        <div class="clearfix"></div>
    </form>
</template>
<script>
    import {UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from "@/event-bus";
    import {CommentBox} from 'src/components';

    export default {
        components:
            {
                MonitoringForm,
                CommentBox
            },
        data() {
            return {
                UserRoles,
                MonitoringForm,
                isClearanceEditable: false,
                isUploadEditable: false,
            }
        },
        async beforeCreate() {
            const vm = this;

            vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
        },
        mounted() {
            setTimeout(function () {
                $('td textarea').each(function () {
                    $(this).css('min-height', $(this).closest('td').height())
                })
            }, 200);

            // disable fields for edit
            var elements  = document.querySelectorAll(".edit-control textarea, .edit-control input[type='text']");
            for (var i = 0, l = elements.length; i < l; ++i) {
                elements[i].readOnly = true;
                elements[i].disabled=true;
            }

            this.isClearanceEditable = !(this.loggedUser.role !== UserRoles.ADMIN && this.loggedUser.role !== UserRoles.REGIONAL_ADMIN) || !MonitoringForm.isEditable;
            this.isUploadEditable = MonitoringForm.isEditable

            if (MonitoringForm.model.revised_logframe.locked)
            {
                this.isClearanceEditable = false;
                this.isUploadEditable = false;
            }
        },
        methods:
            {
                getError(field) {
                    return this.errors.first(field);
                },
                validate() {
                    return this.$validator.validateAll().then(res => {
                        this.$emit('on-validated', res, this.model);

                        return res;
                    });
                },
                saveProgress() {
                    EventBus.$emit('monitoring-save-progress');
                },

                submit() {
                    EventBus.$emit('monitoring-submit');
                },
                async validateLogframe()
                {
                    MonitoringForm.model.revised_logframe.locked = true;
                    MonitoringForm.model.revised_logframe.status = 'LOCKED';

                    this.isClearanceEditable = false;
                    this.isUploadEditable = false;

                    EventBus.$emit('monitoring-save-progress');
                },
            },
    };
</script>
